const SET_LOADING = (state, status) => {
  state.loading = status
}

const SET_ERROR = (state, error) => {
  state.error = error
}

const DISMISS_ERROR = (state) => {
  state.error = false
}

const SET_MAINTENANCE_STATUS = (state, data) => {
  state.maintenance = data
}

export default {
  SET_ERROR,
  SET_LOADING,
  DISMISS_ERROR,
  SET_MAINTENANCE_STATUS
}
